import React from 'react';

import { useTranslation } from 'react-i18next';

import { AVAILABLES } from '../../../../../../constants/availables';
import { COUNTRIES } from '../../../../../../constants/countries';
import { FormDateStyled, FormSelectStyled, FormTextStyled, FormWrapperStyled } from '../../styles';

interface IProps {
  isEditable: boolean;
}

const ProfessionalTab = React.memo(({ isEditable }: IProps) => {
  const { t } = useTranslation();

  const availables = React.useMemo(
    () => AVAILABLES.map((item) => ({ ...item, label: t(`general.${item.label}`) })),
    [t],
  );

  return (
    <FormWrapperStyled spacing={1.5}>
      <FormTextStyled
        label={t('general.first_name')}
        name="firstname"
        disabled={!isEditable}
        dynamicWidth
      />

      <FormTextStyled
        label={t('general.last_name')}
        name="lastname"
        disabled={!isEditable}
        dynamicWidth
      />

      <FormTextStyled label={t('general.phone')} name="phone" disabled={!isEditable} />
      <FormTextStyled label={t('general.email')} name="email" disabled={!isEditable} />

      <FormTextStyled
        label={t('general.phone_professional')}
        name="phone_professional"
        disabled={!isEditable}
      />

      <FormTextStyled
        label={t('general.email_secondary')}
        name="email_secondary"
        disabled={!isEditable}
      />

      <FormTextStyled label={t('general.linkedin')} name="linkedin" disabled={!isEditable} />
      <FormTextStyled label={t('general.address')} name="address" disabled={!isEditable} />

      <FormTextStyled
        label={t('general.address_secondary')}
        name="address_secondary"
        disabled={!isEditable}
      />

      <FormTextStyled label={t('general.postal_code')} name="postalcode" disabled={!isEditable} />

      <FormSelectStyled
        label={t('general.country')}
        name="country"
        items={COUNTRIES}
        isDisabled={!isEditable}
      />

      <FormTextStyled label={t('general.city')} name="city" disabled={!isEditable} />

      <FormDateStyled label={t('general.birthday')} name="birthday" disabled={!isEditable} />

      <FormSelectStyled
        label={t('profile.availability')}
        name="available"
        items={availables}
        isDisabled={!isEditable}
      />

      <FormDateStyled
        label={t('general.available_after')}
        name="dateAvailable"
        disabled={!isEditable}
      />
    </FormWrapperStyled>
  );
});

export default ProfessionalTab;
